/**
 * Frequently asked questions.
 *
 * Section shell converted from `public/index.html:366-371` and `:471-472`; the
 * question and answer text is in `faqEntries.ts`. Accordion behaviour is
 * `:608-621`: clicking the open item closes it, and only one is open at a time.
 */
import { useState } from 'react';

import { FAQ_ENTRIES } from './faqEntries';

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="faq-section">
      <div className="section-header">
        <h2 className="section-title">Frequently Asked Questions</h2>
        <p className="section-subtitle">
          Find answers to common questions about LungChat
        </p>
      </div>
      <div className="faq-container">
        {FAQ_ENTRIES.map((entry, index) => (
          <div
            className={`faq-item${openIndex === index ? ' active' : ''}`}
            key={entry.question}
          >
            <button
              className="faq-question"
              onClick={() =>
                setOpenIndex((cur) => (cur === index ? null : index))
              }
            >
              <span>{entry.question}</span>
              <svg
                className="faq-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>
            <div className="faq-answer">
              {entry.answer.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FaqSection;
